import { ComponentChildren } from 'preact'
import { Segment } from 'semantic-ui-react'
import css from './scrollableSegment.module.css'

export const ScrollableSegment = ({ children }: { children: ComponentChildren }) => {
  return (
    <Segment inverted className={css.scrollableContainer}>
      {children}
    </Segment>
  )
}
